import {makeAutoObservable} from 'mobx';
import {TitleSectionTemplate} from '../../entity/model/title-section-template';
import TitleSectionTemplateAgent from '../agent/title-section-template-agent';
import {RequestBody} from '../../entity/core/request-body';

export default class TitleSectionTemplateStore {
  titleSectionTemplates: TitleSectionTemplate[] = [];
  cache: boolean = false;
  titleSectionTemplateAgent: TitleSectionTemplateAgent;

  constructor(titleSectionTemplateAgent: TitleSectionTemplateAgent) {
    makeAutoObservable(this);
    this.titleSectionTemplateAgent = titleSectionTemplateAgent;
  }

  getTitleSectionTemplates = async (organizationId: string): Promise<TitleSectionTemplate[]> => {
    try {
      this.titleSectionTemplates = await this.titleSectionTemplateAgent.getTitleSectionTemplates(organizationId);
      this.cache = true;
    } catch (error: any) {
      console.error('Error occurred while loading the title section templates', error);
    }

    return this.titleSectionTemplates;
  }

  createTitleSectionTemplate = async (organizationId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      const response = await this.titleSectionTemplateAgent.createTitleSectionTemplate(organizationId, requestBody);

      if (response)
        this.cache = false;
    } catch (error: any) {
      console.error('Error occurred while creating the title section template', error);
      return 'Error occurred while creating the title section template !!';
    }
  }

  updateTitleSectionTemplate = async (organizationId: string, titleSectionTemplateId: string, requestBody: RequestBody): Promise<string | undefined> => {
    try {
      const response = await this.titleSectionTemplateAgent.updateTitleSectionTemplate(organizationId, titleSectionTemplateId, requestBody);

      if (response)
        this.cache = false;
    } catch (error: any) {
      console.error('Error occurred while updating the title section template', error);
      return 'Error occurred while updating the title section template !!';
    }
  }

  deleteTitleSectionTemplate = async (organizationId: string, titleSectionTemplateId: string): Promise<string | undefined> => {
    try {
      await this.titleSectionTemplateAgent.deleteTitleSectionTemplate(organizationId, titleSectionTemplateId);
      this.cache = false;
    } catch (error: any) {
      console.error('Error occurred while deleting the title section template', error);
      return 'Error occurred while deleting the title section template !!';
    }
  }
}
